import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
    blueButton: {
        width: '100%',
        backgroundColor: '#15325C',
        fontFamily: 'Montserrat',
        fontSize: '0.85rem',
        color: '#FFFFFF',
        marginTop: '1.25rem',
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        borderRadius: '0.625rem',
        boxShadow: '0rem 0.125rem 0.25rem #ED2D5D33',
        textTransform: 'capitalize',
        fontWeight: '600',
        cursor: 'pointer',
    },
    grayButton: {
        width: '100%',
        backgroundColor: '#F5F8FF',
        fontFamily: 'Montserrat',
        fontSize: '0.875rem',
        color: '#ED2D5D',
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        borderRadius: '0.625rem',
        boxShadow: '0rem 0.125rem 0.25rem #EDD5D33',
        marginTop: '1.25rem',
        marginBottom: '1.25rem',
        textTransform: 'capitalize',
        fontWeight: '600',
        cursor: 'pointer',
    },
    redButton: {
        width: '100%',
        background: 'linear-gradient(90deg, #E02A58, #C00333)',
        fontFamily: 'Montserrat',
        fontSize: '0.85rem',
        color: '#FFFFFF',
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        borderRadius: '0.625rem',
        boxShadow: '0.125rem 0.25rem 0.625rem #ED2D5D33',
        marginTop: '1.25rem',
        textTransform: 'capitalize',
        fontWeight: '600',
        cursor: 'pointer',
    },
    whiteButton: {
        width: '100%',
        background: '#FFFFFF',
        fontFamily: 'Montserrat',
        fontSize: '0.85rem',
        color: '#C00333',
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        borderRadius: '0.625rem',
        border: '1px solid #E02A58',
        boxShadow: '0.125rem 0.25rem 0.625rem #ED2D5D33',
        marginTop: '1.25rem',
        textTransform: 'capitalize',
        fontWeight: '600',
        cursor: 'pointer',
    },
}));

const ButtonBase = ({
 caption, colorBase, disabled, onClickEvent,
}) => {
    const classes = useStyles();

    // Evento de click
    const handleClick = () => {
        if (onClickEvent) {
            onClickEvent();
        }
    };

    /**
     * @name handleColor
     * @desc Se selecciona el color del boton segun sea el caso
     * @param color
     * @returns {string}
     */
    const handleColor = (color) => {
        switch (color) {
            case 'BLUE':
                return classes.blueButton;
            case 'GRAY':
                return classes.grayButton;
            case 'RED':
                return classes.redButton;
            case 'WHITE':
                return classes.whiteButton;
            default:
                return classes.blueButton;
        }
    };

    return (
      <Button
        variant="contained"
        className={handleColor(colorBase)}
        disabled={disabled}
        type="submit"
        onClick={handleClick}
      >
        {caption}
      </Button>
    );
};

ButtonBase.defaultProps = {
    disabled: false,
    onClickEvent: null,
};

ButtonBase.propTypes = {
    // Label del boton a mostrar
    caption: PropTypes.string.isRequired,
    // Color para seleccionar como se va a mostrar
    colorBase: PropTypes.string.isRequired,
    // Deshabilita el boton
    disabled: PropTypes.bool,
    // Funcion que dispara el evento de click
    onClickEvent: PropTypes.func,
};

export default ButtonBase;
